export const arrayToFieldArray = (arr: any[] = []) =>
  arr.map((value) => ({ value }));
